import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNotification } from '../../hooks/NotificationContext';
import { getJiraAuthUrl } from '../../modules/users';
import Modal from '../elements/Modal';
import { useParams } from 'react-router-dom';
import { jiraChangeWarning } from '../../static/common';

const ChangeSiteModal = ({ show, handleClose, mode = 'change-site' }) => {
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { addNotification } = useNotification();
  const { projectId } = useParams();

  const handleConfirmClose = () => {
    handleClose();
    setResponseData([]);
  };

  const handleConnectToJira = async () => {
    setLoading(true);
    try {
      const response = await getJiraAuthUrl(mode, projectId);
      window.location.href = response;
    } catch (error) {
      addNotification('danger', 'Failed to connect to Jira. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Modal
      open={show}
      width="md"
      handleClose={loading ? null : handleConfirmClose}
      modalTitle={
        mode === 'reauth'
          ? 'Reauthenticate JIRA'
          : 'Confirm JIRA Site Change'
      }
      action={() =>
        loading ? null : (
          <>
            <Button
              variant="outline-secondary"
              onClick={handleConfirmClose}
              title="Cancel">
              Cancel
            </Button>
            {responseData && responseData.length === 0 && (
              <Button
                variant="danger"
                onClick={handleConnectToJira}
                title="Confirm">
                Confirm
              </Button>
            )}
          </>
        )
      }>
      {loading ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 4 }}>
          <CircularProgress size={30} />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Connecting to Jira...
          </Typography>
        </Box>
      ) : (
        <>
          {mode === 'reauth' ? (
            <>
              <p>
                This will refresh your Jira access token. Your Jira connection is still active, and no data will be changed.
                Your workspace, projects, and linked issues will remain unaffected.
              </p>

              <strong>Do you want to continue?</strong>
            </>
          ) : (
            <>
              {jiraChangeWarning('site')}
              <p>This action cannot be undone. Please make sure you want to proceed.</p>
              <strong>Are you sure you want to change the JIRA site?</strong>
            </>
          )}
        </>
      )}
    </Modal>
  );
};

export default ChangeSiteModal;
